import { render, staticRenderFns } from "./TransparenciaDecretos.vue?vue&type=template&id=a636af80&scoped=true&"
import script from "./TransparenciaDecretos.vue?vue&type=script&lang=ts&"
export * from "./TransparenciaDecretos.vue?vue&type=script&lang=ts&"
import style0 from "./TransparenciaDecretos.vue?vue&type=style&index=0&id=a636af80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a636af80",
  null
  
)

export default component.exports